import { useMsal } from "@azure/msal-react";
import React, { useEffect, useState } from "react";
import { getLoggedInUserUsingAccessToken } from "../../API/User/User";

function useUser() {

    const { accounts } = useMsal();

    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        try {
            debugger
            if (accounts.length > 0) {
                setLoading(false);
                setUser(accounts[0]);
            } else {
                getLoggedInUserUsingAccessToken()
                    .then(user => {
                        debugger
                        setUser(user);
                    })
                    .catch(error => {
                        setError(error.message);
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            }
        } catch (e) {
            setLoading(false);
            setError(e.message);
        }
    }, []);

    return [loading, user, error];
}

export default useUser;